import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// console.log('🚀 main.jsx starting - React app initialization')
// console.log('📍 Current URL:', window.location.href)
// console.log('🔧 Environment:', import.meta.env.MODE)

try {
  const root = ReactDOM.createRoot(document.getElementById('root'))
  // console.log('✅ Root element found:', document.getElementById('root'))
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
  // console.log('✅ React app rendered successfully')
} catch (error) {
  // console.error('❌ Error rendering React app:', error)
}
